export default "__VITE_ASSET__7f5e7d88__"